import { render } from "./CheckboxGroup.vue?vue&type=template&id=71fbae6c&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=71fbae6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71fbae6c"

export default script